
import { TimelineConnector, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from '@mui/lab';
import dayjs from 'dayjs';
import React from 'react';

import SurveillanceContent from '../SurveillanceContent/SurveillanceContent';
import { getExamPropertyFromWorkflow } from '../utils/getExamPropertyFromWorkflow';
import { MatchIconFromExam } from '../utils/MatchIconFromExam';
import { useCurrentWorkflow } from 'FRONTEND/utils/nonSerializableStorage/useCurrentWorkflow';

const SurveillanceItem = ({ surveillanceEvent, showOrigin, onClick = (_surveillanceEvent) => {} }) => {
  const currentWorkflow = useCurrentWorkflow();
  const eventKey = Object.keys(surveillanceEvent?.values ?? {})[0];
  const hourType = surveillanceEvent?.values[eventKey]?.surveillance_hours ? 'surveillance_hours' : 'scores_hours';
  const surveillanceEventDate = dayjs(surveillanceEvent?.values[eventKey]?.[hourType]?.value).isValid() ? dayjs(surveillanceEvent?.values[eventKey]?.[hourType]?.value) : dayjs(surveillanceEvent.date);
  return (
    <TimelineItem onClick={() => onClick(surveillanceEvent)}>
      <TimelineOppositeContent
        sx={{ m: 'auto 0', flex: 0 }}
        align='left'
        variant='h6'
        color='text.secondary'
      >
        {surveillanceEventDate.format('HH:mm')}
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineConnector />
        <TimelineDot color='primary'>
          <MatchIconFromExam
            examIcon={getExamPropertyFromWorkflow({ examId: surveillanceEvent.examName, targetedProperty: 'icon', workflow: currentWorkflow })}
          />
        </TimelineDot>
        <TimelineConnector />
      </TimelineSeparator>
      <SurveillanceContent surveillanceEvent={surveillanceEvent} showOrigin={showOrigin} />
    </TimelineItem>
  );
};

export default SurveillanceItem;
